exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".over-all-usage .card[data-v-a739e7f2] {\n  width: -webkit-calc(50% - 10px);\n  width: calc(50% - 10px);\n  padding: 15px;\n  border: 1px solid #f1f2f5;\n  border-radius: 10px;\n}\n.over-all-usage .card .num[data-v-a739e7f2] {\n  font-size: 28px;\n  font-weight: 600;\n  color: #1eaed2;\n}\n.over-all-usage .card .symbol[data-v-a739e7f2] {\n  margin: 0 6px;\n  font-size: 18px;\n  font-weight: bold;\n  color: #51abf5;\n}\n.over-all-usage .tip[data-v-a739e7f2] {\n  padding: 15px;\n  border-radius: 10px;\n  line-height: 1.8;\n  background-color: #fdfde5;\n}\n", ""]);

// exports
